import DraftNumberInput from "../../../inputs/DraftNumberInput";
import ProductWidgetContainer from "./ProductWidgetContainer";

const GenericUsersProductWidget = ({
  product,
  onRemove,
  onProductChange,
  editable,
  baselineProfile,
  deploymentType,
}: {
  product: ProductOptionInterface;
  onRemove: () => void;
  onProductChange: (updatedProduct: ProductOptionInterface) => void;
  editable: boolean;
  baselineProfile: string;
  deploymentType: string;
}) => {
  const handleProfileChange = (newProfile: string) => {
    const productCopy = { ...product, profile: newProfile };
    onProductChange(productCopy);
  };

  return (
    <ProductWidgetContainer
      onRemove={onRemove}
      title={product?.name}
      productKey={product.key}
      canBeRemoved={product?.canBeRemoved}
      productProfile={product.profile}
      deploymentType={deploymentType}
      onProfileChange={handleProfileChange}
    >
      <DraftNumberInput
        label="Concurrent Users"
        product={product}
        field="concurrentUsers"
        baselineProfile={baselineProfile}
        editable={editable}
        onProductChange={onProductChange}
      />
    </ProductWidgetContainer>
  );
};

export default GenericUsersProductWidget;
